var _path, _path2, _path3, _path4, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7504 10.2707C12.4629 9.98021 12.2574 9.77252 12.0312 9.54413C13.3323 8.24433 14.6203 6.95603 15.9634 5.61331H13.6274V4.69824H17.5382V8.61297H16.6557V6.35595C15.347 7.66724 14.0568 8.96014 12.7496 10.2699L12.7504 10.2707Z",
    fill: "url(#paint0_linear_1095_9370)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36291 10.1437C9.6504 9.85326 9.85587 9.64556 10.082 9.41718C8.78101 8.11738 7.49303 6.82908 6.14984 5.48636H8.48585V4.57129H4.57513V8.48601H5.45755V6.22899C6.76624 7.54029 8.05652 8.83319 9.36367 10.143L9.36291 10.1437Z",
    fill: "url(#paint1_linear_1095_9370)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59099 15.9216C6.91884 14.5927 8.20529 13.3059 9.51014 12C9.75011 12.2606 9.9456 12.4736 10.1725 12.7196C8.90372 13.9857 7.61036 15.2756 6.25338 16.6298H8.61239V17.5395H4.70703V13.6156H5.59175V15.9216H5.59099Z",
    fill: "url(#paint2_linear_1095_9370)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5184 15.8562C15.1905 14.5273 13.9041 13.2405 12.5992 11.9346C12.3593 12.1951 12.1638 12.4082 11.9368 12.6542C13.2057 13.9203 14.499 15.2101 15.856 16.5643H13.497V17.474H17.4023V13.5501H16.5176V15.8562H16.5184Z",
    fill: "url(#paint3_linear_1095_9370)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 4.5,
    stroke: "url(#paint4_linear_1095_9370)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1095_9370",
    x1: 14.7847,
    y1: 4.69824,
    x2: 14.7847,
    y2: 10.2707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1095_9370",
    x1: 7.32858,
    y1: 4.57129,
    x2: 7.32858,
    y2: 10.1437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1095_9370",
    x1: 7.43978,
    y1: 12,
    x2: 7.43978,
    y2: 17.5395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1095_9370",
    x1: 14.6696,
    y1: 11.9346,
    x2: 14.6696,
    y2: 17.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1095_9370",
    x1: 11,
    y1: 1,
    x2: 11,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandFilter);
export default __webpack_public_path__ + "static/media/expand_filter.79d7473cd03ae733eadaaefe39268112.svg";
export { ForwardRef as ReactComponent };